import { useMount, useSetState } from "ahooks";
import { PasscodeInput, Popup } from "antd-mobile";
import { PropsWithChildren, useRef } from "react";
import { PasswordKitBEM } from ".";
import { PasswordKitKeyBoard } from "./keyboard";

export type PasswordKitInputProps = PropsWithChildren<{
  withPopKeyboard?: boolean;
  withKeyboard?: boolean;
  onFill?: (text: string) => void;
}>;

export const PasswordKitInput = ({
  withPopKeyboard,
  withKeyboard,
  onFill,
}: PasswordKitInputProps) => {
  const b = PasswordKitBEM;
  const [state, setState] = useSetState({
    text: "",
    showKeyboard: false,
  });
  const ref = useRef(null);

  useMount(() => {
    // @ts-ignore 组件上的方法
    if (ref.current && ref.current.focus) ref.current.focus();
  });

  const keyboard = (
    <PasswordKitKeyBoard
      onChange={(key) => {
        // @ts-ignore 组件上的方法
        if (ref.current && ref.current.focus) ref.current.focus();

        if (key === "删除") {
          // 删除最后一个字符
          setState((prev) => ({
            text: prev.text.slice(0, prev.text.length - 1),
          }));
          return;
        }

        const newText = state.text + key;

        if (newText.length <= 6) {
          setState({ text: newText });
        }

        if (newText.length === 6) {
          onFill?.(newText);
          // @ts-ignore 组件上的方法
          if (ref.current && ref.current.blur) ref.current.blur();
          return;
        }
      }}
    />
  );

  return (
    <>
      <PasscodeInput
        className={b("input")}
        ref={ref}
        value={state.text}
        seperated
        keyboard={
          withKeyboard ? (
            withPopKeyboard ? (
              <Popup className={b("popup")} visible={state.showKeyboard}>
                {keyboard}
              </Popup>
            ) : (
              keyboard
            )
          ) : undefined
        }
        onFocus={() => setState({ showKeyboard: true })}
        onBlur={() => setState({ showKeyboard: false })}
      />
      {!withKeyboard && (
        <Popup className={b("popup")} visible={state.showKeyboard}>
          {keyboard}
        </Popup>
      )}
    </>
  );
};
